/* eslint-disable */
<template>
  <div style="padding: 0; margin: 0" v-if="!isLoading || !isNeedGetHomework">
    <div class="right-box">
      <div class="tittle-position-box">
        <div class="answer-box-title tittle-position">
          <span>正确答案</span>
          <span v-if="question.questionType <= 3">
            {{ question.rightAnswerText }}</span
          >&nbsp;&nbsp; <br />
          <p style="color: #409eff" @click="onShowAnswer(question)">查看答案</p>
        </div>
        <div class="answer-box-title tittle-position">
          <span style="margin-left: 0">作答统计</span> &nbsp;&nbsp;
          <el-popover
            placement="left"
            width="400"
            overflow-y="scroll"
            trigger="click"
            class="el-popper-box"
            popper-class="popoverStyle"
          >
            <div class="" v-for="(answer, i1) in answerMap" :key="i1">
              <div class="answer-title">
                {{ answer.name }}
                <el-button
                  type="text"
                  size="mini"
                  @click="onAnswerExpand(answer)"
                  >{{ answer.expand ? "收起" : "展开" }}</el-button
                >
              </div>
              <div v-if="answer.expand">
                <span
                  v-for="(student, i2) in answer.studentList"
                  :key="i2"
                  :class="
                    'answer-student ' +
                    (studentId === student.id ? ' answer-student-select' : '')
                  "
                  @click="onStudentChange(student)"
                  >{{ student.realName }}</span
                >
              </div>
            </div>
            <el-button style="position: relative" type="text" slot="reference">
              <!-- <br> -->
              查看</el-button
            >
          </el-popover>
        </div>
        <div>
          <el-button
            @click="selectChange2"
            style="position: relative"
            type="text"
            >{{ sort == 1 ? "按正确率" : "按题号" }}⇋</el-button
          >
        </div>
        <div v-if="wrongScan">
          <el-button
            @click="selectChange3"
            style="position: relative"
            type="text"
            >{{ needExplain == true ? "显示全部" : "需讲评" }}⇋</el-button
          >
        </div>
      </div>
      <div class="right-box-top">
        <div>
          <div
            style="position: fixed; right: 21px; font-size: 2vh"
            :style="{ bottom: !wrongScan ? '52vh' : '60vh' }"
            class="answer-box-title answer-box-title-ans"
          >
            试题
          </div>
          <el-select
            v-if="wrongScan"
            size="mini"
            class="select"
            style="position: fixed; bottom: 56vh; right: 21px; width: 120px"
            v-model="value"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-if="wrongScan && materials == 1"
            size="mini"
            class="select"
            style="position: fixed; bottom: 52vh; right: 21px; width: 120px"
            v-model="chapt"
            placeholder="请选择"
          >
            <el-option
              v-for="item in chapterList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="needExplain && !item.needExplain ? true : false"
            >
            </el-option>
          </el-select>
          <!-- <div v-for="qst in questionList" :key="qst.questionNum" :class="'qst-no-box ' + ' qst-no-box-border-r' + qst.difficulty + (qst.id === questionId ? ' qst-no-box-select-r' + qst.difficulty : '')" @click="onQuestionChange(qst)"> -->
          <div
            style="
              padding: 0.8vh;
              margin-right: 20px;
              float: right;
              font-size: 1.5vh;
            "
            v-for="qst in questionList"
            :key="qst.questionNum"
            v-show="needExplain ? qst.needExplain : true"
            :class="
              'qst-no-box ' +
              'qst-no-box-border-r' +
              (qst.classScoreRatio >= 0 && qst.classScoreRatio < 0.6
                ? '2'
                : qst.classScoreRatio >= 0.6 && qst.classScoreRatio < 0.7
                ? '3'
                : qst.classScoreRatio >= 0.7 && qst.classScoreRatio < 0.85
                ? '3'
                : '4') +
              (qst.id === questionId
                ? ' qst-no-box-select-r' +
                  (qst.classScoreRatio >= 0 && qst.classScoreRatio < 0.6
                    ? '2'
                    : qst.classScoreRatio >= 0.6 && qst.classScoreRatio < 0.7
                    ? '3'
                    : qst.classScoreRatio >= 0.7 && qst.classScoreRatio < 0.85
                    ? '3'
                    : '4')
                : '')
            "
            @click="onQuestionChange(qst)"
          >
            {{ qst.questionNum || qst.questionAlias }}
            <br />
            {{
              !isNaN(qst.classScoreRatio) && qst.classScoreRatio != null
                ? Math.floor(qst.classScoreRatio.toFixed(2) * 100) + "%"
                : "0%"
            }}
          </div>
        </div>
        <div style="height: 3vh; position: fixed; bottom: 6vh; right: 11px">
          <span
            :class="'qst-rt ' + (qstIndex === 1 ? ' qst-rt-select' : '')"
            @click="onQstIndex(1)"
            >原题</span
          >
          <span
            v-if="question.exerciseIds && question.exerciseIds.length > 0"
            :class="'qst-rt ' + (qstIndex === 2 ? ' qst-rt-select' : '')"
            @click="onQstIndex(2)"
            >变试题1</span
          >
          <span
            v-if="question.exerciseIds && question.exerciseIds.length > 1"
            :class="'qst-rt ' + (qstIndex === 3 ? ' qst-rt-select' : '')"
            @click="onQstIndex(3)"
            >变试题2</span
          >
          <span
            v-if="question.exerciseIds && question.exerciseIds.length > 2"
            :class="'qst-rt ' + (qstIndex === 4 ? ' qst-rt-select' : '')"
            @click="onQstIndex(4)"
            >变试题3</span
          >
        </div>
      </div>
      <div class="page-box">
        <el-button
          size="mini"
          type="button"
          icon="el-icon-arrow-left"
          plain
          @click="preClick"
        ></el-button>
        <span class="page-num">{{ pageStr }}</span>
        <el-button
          size="mini"
          type="button"
          icon="el-icon-arrow-right"
          plain
          @click="nextClick"
        ></el-button>
        <el-button size="mini" type="button" @click="nextFull">{{
          isFullscreen ? "退出" : "全屏"
        }}</el-button>
      </div>
    </div>

    <div>
      <FabricBoard ref="board" />
    </div>
    <SelectHomework
      v-if="homeworkId != '00000'"
      :homeworkDialogVisible="homeworkDialogVisible"
      :homeworkId="homeworkId"
      :defaultClassId="classId"
      @changeHomeworkId="changeHomeworkId"
    />
  </div>
</template>

<script>
/* eslint-disable */
import {
  getExamQuesList,
  getStudentAnswerInfo,
  getStudentAnswerInfo2Api,
  html2image,
  getAccuracyApi, // 错题卡获取正确率
  getHomeworkList,
  getHomeworkApi,
} from "../apis/explainApi";
import { getProject } from "../apis/projectApi";
import FabricBoard from "../components/explain/FabricBoard";
import SelectHomework from "../components/explain/SelectHomework";
import md5 from "js-md5";
import screenfull from "screenfull";
import { Message } from "element-ui";
import { setToken } from "../utils/auth";
var data = null;
export default {
  name: "Explain",
  components: {
    FabricBoard,
    SelectHomework,
  },
  data() {
    return {
      needExplain: false,
      questionData: null,
      materials: 3,
      chapt: null,
      chapterList: [],
      options: [],
      wrongScan: null,
      errorCard: null,
      sort: 1,
      value: null,
      boardWidth: 800,
      token: undefined,
      homeworkId: undefined,
      classId: undefined,
      questionList: [],
      questionId: undefined,
      question: {},
      studentId: undefined,
      answerInfo: {
        stuAnswerInfos: undefined,
        stuAnswerStat: undefined,
        userList: undefined,
      },
      answerMap: [],
      loading: undefined,
      isLoading: false,
      qstIndex: 1,
      boardNum: 1,
      isFullscreen: false,
      pageStr: "1/1",
      pageCountMap: {},
      exerciseQstBoardMap: {},
      exerciseId: undefined,
      qstLoadedMap: {},
      homeworkDialogVisible: false,
      selectedHomework: undefined,
      isNeedGetHomework: false,
    };
  },
  async created() {
    console.log(this.$route.params, "this.$route.params");

    this.homeworkId =
      this.$route.params.homeworkId == "undefined" ||
      this.$route.params.homeworkId === "" ||
      this.$route.params.homeworkId === null
        ? undefined
        : this.$route.params.homeworkId;
    this.classId =
      this.$route.params.classId == "undefined" ||
      this.$route.params.classId === "" ||
      this.$route.params.classId === null
        ? undefined
        : this.$route.params.classId;
    this.token = this.$route.params.token;
    this.wrongScan = this.$route.params.wrongScan || null;
    this.errorCard = this.$route.params.errorCard || null;
    this.isNeedGetHomework = this.$route.query.isNeedGetHomework == 1;

    if (this.token === null || this.token === undefined || this.token === "") {
      Message({
        message: "token不能为空",
        type: "error",
      });
      return;
    }
    setToken(this.token);
    //当homeworkId和classId为空时 跳出弹框先选作业
    if (!this.homeworkId || !this.classId) {
      console.log(this.isNeedGetHomework, "this.isNeedGetHomework");
      if (this.isNeedGetHomework) {
        this.openLoading();
        this.isLoading = true;
        let response;
        try {
          response = await getHomeworkList(302, 1, 1);
        } catch (error) {
          this.closeLoading();
          this.isLoading = false;
          this.homeworkDialogVisible = true;
          return;
        }
        this.closeLoading();
        this.isLoading = false;
        if (response.data.homeworkList.length > 0) {
          this.homeworkId = response.data.homeworkList[0].homeworkId;
          if (response.data.homeworkList[0].classIds.length > 0) {
            this.classId = response.data.homeworkList[0].classIds[0];
          } else {
            this.homeworkDialogVisible = true;
            return;
          }
        } else {
          this.homeworkDialogVisible = true;
          return;
        }
      } else {
        this.homeworkDialogVisible = true;
        return;
      }
    }
    console.log(this.homeworkId, this.wrongScan, "this.wrongScan");
    if (this.homeworkId == "00000" && this.wrongScan) {
      this.getProjectFun();
      return;
    } else {
      this.getQuestionList();
    }
  },
  mounted() {
    console.log("mounted");
    // 监听全屏状态变化
    screenfull.onchange(() => {
      console.log("当前全屏状态：", screenfull.isFullscreen);
      this.isFullscreen = screenfull.isFullscreen;
    });
  },
  methods: {
    getProjectFun() {
      getProject(this.wrongScan, 2).then((response) => {
        console.log(response);
        data = response.data.materialChapterMap || response.data.examItemMap;
        this.questionData = response.data;

        const processData = (source, materialsValue) => {
          if (source) {
            this.materials = materialsValue;
            this.options = Object.values(source).map((item) => ({
              value: item.id,
              label: item.name,
            }));
          }
        };

        processData(response.data.materials, 1);
        processData(response.data.examMap, 2);

        this.value = this.options[0].value;
      });
    },
    getQuestionList() {
      getExamQuesList(this.homeworkId, this.classId).then((response) => {
        console.log(response);
        this.questionList = response.data.questionList;
        if (
          this.questionId === undefined &&
          this.questionList &&
          this.questionList.length > 0
        ) {
          this.question = this.questionList[0];
          this.questionId = this.question.id;
          this.switchBoard(this.questionId, this.boardNum);
          this.loadQuestionImage(this.questionId, "baseImg");
          this.qstLoadedMap[this.questionId] = this.questionId;
        }
        this.getAnswerInfo();
      });
    },
    onQuestionChange(row) {
      this.question = row;
      let questionId = this.question.id;
      if (questionId !== this.questionId) {
        this.boardNum = 1;
        this.switchBoard(questionId, this.boardNum);
      }
      if (!this.qstLoadedMap[questionId] || questionId === this.questionId) {
        this.loadQuestionImage(questionId, "baseImg");
        this.qstLoadedMap[questionId] = questionId;
      }
      this.questionId = questionId;
      this.getAnswerInfo();

      if (!this.pageCountMap[this.questionId]) {
        this.pageCountMap[this.questionId] = 1;
      }
      this.pageCountMap[this.questionId] =
        this.pageCountMap[this.questionId] < this.boardNum
          ? this.boardNum
          : this.pageCountMap[this.questionId];
      let pageCount = this.pageCountMap[this.questionId];
      this.pageStr = this.boardNum + "/" + pageCount;
    },
    loadQuestionImage(id, key) {
      let questionUrl = this.getQuestionUrl(id, true, false);
      this.getQuestionImage(questionUrl, 200, key);
    },
    onShowAnswer(row) {
      console.log(row);
      let id = this.qstIndex <= 1 ? this.questionId : this.exerciseId;
      if (!id) {
        Message({
          message: "该题不存在",
          type: "error",
        });
        return;
      }
      let answerUrl = this.getQuestionUrl(id, false, true);
      this.getQuestionImage(answerUrl, 200);
    },
    getAnswerInfo() {
      this.studentId = undefined;
      this.answerInfo = {
        stuAnswerInfos: undefined,
        stuAnswerStat: undefined,
        userList: undefined,
      };
      if (this.wrongScan && this.homeworkId == "00000") {
        getStudentAnswerInfo2Api(
          this.wrongScan,
          this.classId,
          this.value,
          this.questionId
        ).then((response) => {
          let answerMap = [
            {
              expand: false,
              name: "【错误】" + response.data.wrongCount + "人",
              studentList: [...response.data.userList],
            },
          ];
          this.answerMap = answerMap;
        });
      } else {
        getStudentAnswerInfo(
          this.homeworkId,
          this.classId,
          this.questionId
        ).then((response) => {
          console.log(response);
          let answerInfo = response.data;
          let stuAnswerInfoList = answerInfo.stuAnswerInfos;
          let stuAnswerInfoMap = {};
          if (stuAnswerInfoList && stuAnswerInfoList.length > 0) {
            for (let i = 0; i < stuAnswerInfoList.length; i++) {
              stuAnswerInfoMap[stuAnswerInfoList[i].userId] =
                stuAnswerInfoList[i];
            }
          }

          let studentList = answerInfo.userList;
          let studentMap = {};
          if (studentList && studentList.length > 0) {
            for (let i = 0; i < studentList.length; i++) {
              let student = studentList[i];
              if (stuAnswerInfoMap[student.id] !== undefined) {
                student.answer = stuAnswerInfoMap[student.id];
              }
              studentMap[student.id] = student;
            }
          }
          let answerMap = [];
          for (const k in answerInfo.stuAnswerStat) {
            let name = k === "#" ? "未作答" : k;
            let v = answerInfo.stuAnswerStat[k];
            name = "【" + name + "】" + v.length + "人";
            let stdList = [];
            for (let j = 0; j < v.length; j++) {
              let id = v[j];
              if (studentMap[id] !== undefined) {
                stdList.push(studentMap[id]);
              }
            }
            answerMap.push({
              name: name,
              expand: false,
              studentList: stdList,
            });
          }
          console.log(
            answerMap,
            "ansMap",
            answerInfo,
            "1111111111111111111111"
          );
          this.answerInfo = answerInfo;
          this.answerMap = answerMap;
        });
      }
    },
    onStudentChange(row) {
      console.log(row);
      this.studentId = row.id;

      //新增一个白板
      this.nextClick();

      //在白板上画图 横着排 控制宽高展示全
      if (
        row.answer &&
        row.answer.answerPictures &&
        row.answer.answerPictures.length > 0
      ) {
        const images = row.answer.answerPictures.map((url) => ({ url }));
        this.$refs.board.addImages(images); // 添加多个图片
      }
    },
    onAnswerExpand(row) {
      row.expand = !row.expand;
    },
    addImage(name, url, top, key) {
      this.$refs.board.addImage(
        {
          name: name,
          url: url,
        },
        top,
        key
      );
    },
    getQuestionUrl(id, withQuestion, withAnswer) {
      let url = "http://www.zuihuixue.com/" + "api/question/" + id;
      url += "?latexStyle=" + true;
      url += "&withQuestion=" + withQuestion;
      url += "&withAnswer=" + withAnswer;
      url += "&withAnalysis=" + withAnswer;
      url += "&withSolution=" + withAnswer;
      return url;
    },
    getQuestionImage(url, top, key) {
      this.openLoading();
      let urlBase64 = btoa(url);
      let refresh = 0;
      // eslint-disable-next-line no-use-before-define
      let fileName = md5(urlBase64) + ".png";
      html2image(urlBase64, refresh, fileName).then((response) => {
        console.log(response);
        if (response.data && response.data.imagePath) {
          this.addImage(fileName, response.data.imagePath, top, key);
          this.closeLoading();
        }
      });
    },
    openLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0)",
      });
    },
    selectChange2() {
      if (this.sort == 1) {
        this.questionList.sort((a, b) => a.classScoreRatio - b.classScoreRatio);
        this.sort = "2";
        return;
      }
      if (this.sort == 2) {
        this.questionList.sort((a, b) => a.questionNum - b.questionNum);
        this.sort = "1";
        return;
      }
    },
    selectChange3() {
      this.needExplain = !this.needExplain;
    },
    closeLoading() {
      this.loading.close();
    },
    onQstIndex(e) {
      console.log(this.question);
      this.qstIndex = e;
      if (this.qstIndex <= 1) {
        // 原题
        this.boardNum = 1;
        this.switchBoard(this.questionId, this.boardNum);
      } else {
        // 变式题
        let q = e - 2;
        if (
          this.question.exerciseIds &&
          this.question.exerciseIds.length >= q &&
          this.question.exerciseIds[q]
        ) {
          let exerciseId = this.question.exerciseIds[q];
          console.log(exerciseId);
          if (!this.exerciseQstBoardMap[exerciseId]) {
            this.boardNum = this.boardNum + 1;
            this.switchBoard(this.questionId, this.boardNum);
            this.exerciseQstBoardMap[exerciseId] = this.boardNum;
            let questionUrl = this.getQuestionUrl(exerciseId);
            console.log(questionUrl);
            this.getQuestionImage(questionUrl);
          } else {
            this.boardNum = this.exerciseQstBoardMap[exerciseId];
            console.log(this.boardNum);
            this.switchBoard(this.questionId, this.boardNum);
          }
          this.exerciseId = exerciseId;
        } else {
          Message({
            message: "该变式题不存在",
            type: "error",
          });
        }
      }
      if (!this.pageCountMap[this.questionId]) {
        this.pageCountMap[this.questionId] = 1;
      }
      this.pageCountMap[this.questionId] =
        this.pageCountMap[this.questionId] < this.boardNum
          ? this.boardNum
          : this.pageCountMap[this.questionId];
      let pageCount = this.pageCountMap[this.questionId];
      this.pageStr = this.boardNum + "/" + pageCount;
    },
    preClick(e) {
      this.boardNum = this.boardNum > 1 ? this.boardNum - 1 : 1;
      this.switchBoard(this.questionId, this.boardNum);
      if (!this.pageCountMap[this.questionId]) {
        this.pageCountMap[this.questionId] = 1;
      }
      this.pageCountMap[this.questionId] =
        this.pageCountMap[this.questionId] < this.boardNum
          ? this.boardNum
          : this.pageCountMap[this.questionId];
      let pageCount = this.pageCountMap[this.questionId];
      this.pageStr = this.boardNum + "/" + pageCount;
    },
    nextClick(e) {
      this.boardNum = this.boardNum + 1;
      this.switchBoard(this.questionId, this.boardNum);
      if (!this.pageCountMap[this.questionId]) {
        this.pageCountMap[this.questionId] = 1;
      }
      this.pageCountMap[this.questionId] =
        this.pageCountMap[this.questionId] < this.boardNum
          ? this.boardNum
          : this.pageCountMap[this.questionId];
      let pageCount = this.pageCountMap[this.questionId];
      this.pageStr = this.boardNum + "/" + pageCount;
    },
    switchBoard(boardId, boardNum) {
      this.$refs["board"].switchBoard(boardId, boardNum);
    },

    nextFull(e) {
      screenfull.toggle().then((res) => {
        this.isFullscreen = screenfull.isFullscreen;
      });
    },
    changeHomeworkId(msg) {
      this.questionId = undefined;
      this.homeworkId = msg.homeworkId;
      this.classId = msg.classId;
      this.selectedHomework = msg.homeworkName;

      if (this.homeworkId == "00000" && this.wrongScan) {
        this.getProjectFun();
        return;
      } else {
        this.getQuestionList();
      }
    },
  },
  watch: {
    value(val) {
      console.log(val);

      this.needExplain = false;
      if (this.materials == 1) {
        let queArr = Object.values(this.questionData.mpqMap)
          .map(Object.values)
          .flat(2);
        this.chapterList = Object.keys(data[val]).map((key) => {
          const { id: value, name: label } = data[val][key];

          let que = queArr.map((item) => {
            if (item.chapterId == data[val][key].id) {
              return item;
            } else {
              return null;
            }
          });
          que = que.filter((item) => item != null);

          const needExplain = que.some((item2) =>
            this.questionData.commentQuestionMap[this.classId].includes(
              item2.questionId
            )
          );
          return { value, label, que, needExplain };
        });

        console.log(this.chapterList, "this.chapterList");
        this.chapt = this.chapterList[0].value;
      } else if (this.materials == 2) {
        this.questionList = [];
        getAccuracyApi(this.wrongScan, this.classId, this.value).then(
          (response) => {
            this.questionList = data[val].map((item) => {
              let needExplain = this.questionData.commentQuestionMap[
                this.classId
              ].some((item2) => item2 == item.questionId);
              return {
                needExplain: needExplain,
                id: item.questionId,
                questionNum: item.questionNoText,
                classScoreRatio:
                  (response.data.scanCount -
                    (response.data.wrongCountMap[item.questionId] || 0)) /
                  response.data.scanCount,
              };
            });

            this.question = this.questionList[0];
            this.questionId = this.question.id;
            this.switchBoard(this.questionId, this.boardNum);
            this.loadQuestionImage(this.questionId, "baseImg");
            this.qstLoadedMap[this.questionId] = this.questionId;
            this.getAnswerInfo();
          }
        );
      }
    },
    chapt(val) {
      this.needExplain = false;
      this.questionList = [];
      getAccuracyApi(this.wrongScan, this.classId, this.value, val).then(
        (response) => {
          let queArr = Object.values(this.questionData.mpqMap)
            .map((item) => {
              return Object.values(item);
            })
            .flat(2);

          const processData = (key) => {
            return queArr.filter((item) => item.chapterId == key) || null;
          };
          this.questionList = processData(val).map((item) => {
            return {
              id: item.questionId,
              questionNum: item.questionNoText,
              classScoreRatio:
                (response.data.scanCount -
                  (response.data.wrongCountMap[item.questionId] || 0)) /
                response.data.scanCount,
              needExplain: this.questionData.commentQuestionMap[
                this.classId
              ].some((item2) => item2 == item.questionId),
            };
          });

          this.question = this.questionList[0];
          this.questionId = this.question.id;
          this.switchBoard(this.questionId, this.boardNum);
          this.loadQuestionImage(this.questionId, "baseImg");
          this.qstLoadedMap[this.questionId] = this.questionId;
          this.getAnswerInfo();
        }
      );
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  height: 1000px !important;
}
.right-box {
  position: fixed;
  right: 0;
  width: 200px;
  height: 100%;
  z-index: 999;
  background-color: white;
  padding: 16px 16px;
}

.qst-no-box {
  border: 1px solid #eaeaea;
  width: 6vh;
  height: 5vh;
  display: inline-block;
  font-size: 14px;
  line-height: 2.5vh;
  text-align: center;
  margin: 0 8px 8px 0;
  background-color: white;
}

.qst-no-box-border-r2 {
  border: 1px solid #d9534f;
}

.qst-no-box-border-r3 {
  border: 1px solid #f89406;
}

.qst-no-box-border-r4 {
  border: 1px solid #5bc0de;
}

.qst-no-box-border-r5 {
  border: 1px solid #5cb85c;
}

.qst-no-box-select-r2 {
  background-color: #d9534f;
  border: 1px solid #d9534f;
  color: white;
}

.qst-no-box-select-r3 {
  background-color: #f89406;
  border: 1px solid #f89406;
  color: white;
}

.qst-no-box-select-r4 {
  background-color: #5bc0de;
  border: 1px solid #5bc0de;
  color: white;
}

.qst-no-box-select-r5 {
  background-color: #5cb85c;
  border: 1px solid #5cb85c;
  color: white;
}

.answer-box-title {
  text-align: left;
  font-size: 14px;
  margin: 8px 0px;
  font-weight: bold;
}

.answer-title {
  font-size: 14px;
  margin: 8px 0px;
}

.answer-student {
  display: inline-block;
  font-size: 13px;
  padding: 3px 5px;
  border: 1px solid #eaeaea;
  margin-right: 20px !important;
  margin-bottom: 8px;
  background-color: white;
}

.answer-student:hover {
  color: white;
  background-color: #0188cc;
  border: 1px solid #0188cc;
}

.answer-student-select {
  color: white;
  background-color: #0188cc;
  border: 1px solid #0188cc;
}

.qst-rt {
  width: 50px;
  display: inline-block;
  font-size: 13px;
  text-align: center;
  padding: 3px 5px;
  border: 1px solid #eaeaea;
  margin-right: 8px;
  margin-bottom: 8px;
  background-color: white;
}

.qst-rt:hover {
  color: white;
  background-color: #0188cc;
  border: 1px solid #0188cc;
}

.qst-rt-select {
  color: white;
  background-color: #0188cc;
  border: 1px solid #0188cc;
}

.page-box {
  display: block;
  position: fixed;
  bottom: 1vh;
  right: 18px;
  height: 3vh;
}

.page-num {
  padding: 2px 8px;
  font-size: 12px;
}

.right-box-top {
  position: absolute;
  width: 13vh;
  height: 40vh;
  overflow-y: scroll;
  overflow-x: visible;
  bottom: 13vh;
  right: 0;
  &::-webkit-scrollbar {
    display: none;
  }
}
.tittle-position-box {
  position: absolute;
  width: 80px;
  right: 12vh;
  bottom: 30vh;
  z-index: 99999;
}
.el-input__inner {
  padding: 0;
}
.el-popper-box {
  height: 200px !important;
  overflow-y: scroll !important;
  &::-webkit-scrollbar {
    display: none !important;
  }
}
.el-input__icon {
  display: none !important;
}
::v-deep.el-input__inner {
  border: 0 !important;
}
::v-deep.el-input__suffix {
  display: none !important;
}
.tittle-position {
  float: left !important;
}
.el-popover {
  height: 100px !important;
  overflow-y: scroll !important;
  &::-webkit-scrollbar {
    display: none !important;
  }
}
</style>
<style lang="">
.el-popover.popoverStyle {
  height: 300px;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Explain.vue